<div class="flowers" *ngIf="showCoinShower">
    <img src="{{ coinShowerImage }}" alt="CoinShower" *ngIf="coinShowerImage" />
</div>
